@if (termin$ | async; as termin) {
  @if (libConfig.showHeader) {
    <div class="container-fluid" nowWbsucheLibScrollToAndFocus [shouldScroll]="true">
      <now-wbsuche-lib-breadcrumb></now-wbsuche-lib-breadcrumb>
    </div>
  }

  <now-wbsuche-lib-befragung-banner></now-wbsuche-lib-befragung-banner>

  <article class="d-flex">
    <div class="flex-shrink-0 w-100">
      <now-wbsuche-lib-detail-header [termin]="termin"> </now-wbsuche-lib-detail-header>
      <div role="presentation" class="container-fluid">
        <now-wbsuche-lib-details [termin]="termin" [currentTab]="(currentTab$ | async)!">
        </now-wbsuche-lib-details>
      </div>
    </div>
  </article>
}
